// Every rule number, from docs/rules.pdf (the official 1st-edition English
// rulebook, eggertspiele 2014) - with page citations. docs/board.jpg is the
// board itself, from the TTS mod.

export const CAMELS = ['blue', 'green', 'orange', 'yellow', 'white']; // p1
export const TRACK_LENGTH = 16; // spaces, flag 1 through 16; finish after 16

// Each die matches a camel and "has the numbers 1, 2, and 3 twice on it" (p1).
export const DIE_MIN = 1;
export const DIE_MAX = 3;

// Leg betting tiles per camel, stacked 5 on top, then 3, then 2 (p2 setup) -
// so the first tile taken from a stack is the 5.
export const LEG_TILE_VALUES = [5, 3, 2];

export const STARTING_MONEY = 3; // p2, "starting capital of 3 Egyptian Pounds"

// Leg scoring (p4): leader's tiles pay their printed value, second place
// pays 1, any other camel costs 1; each pyramid tile pays 1.
export const SECOND_PLACE_PAYOUT = 1;
export const WRONG_LEG_TILE_PENALTY = 1;
export const PYRAMID_TILE_PAYOUT = 1;

// A camel unit ending on your desert tile pays you 1 EP at once (p3).
export const DESERT_TRIGGER_PAYOUT = 1;

// End scoring (p4): cards showing the actual winner pay 8/5/3/2 in the order
// placed, then 1 each; every card showing any other camel costs 1. The loser
// deck works the same way.
export const FINAL_BET_PAYOUTS = [8, 5, 3, 2];
export const FINAL_BET_CONSOLATION = 1;
export const WRONG_FINAL_BET_PENALTY = 1;

export const MIN_PLAYERS = 2; // box says 2-8
export const MAX_PLAYERS = 8;

export const PHASES = { PLAYING: 'playing', FINISHED: 'finished' };
